import { type ActivityElement, ActivityStatus } from "@octopusdeploy/octopus-server-client";
import { useMemo } from "react";
import type { StepWithKubernetesAction } from "~/areas/tasks/components/Task/K8sStatus/StepWithKubernetesAction";
import { getStepActivity } from "~/areas/tasks/components/Task/K8sStatus/getStepActivity";
import { useDeepCompareMemo } from "~/hooks/useDeepCompareMemo";
export type KubernetesStepWithStatus = StepWithKubernetesAction & {
    status: ActivityStatus | undefined;
};
export function useKubernetesStepsWithStatus(kubernetesSteps: StepWithKubernetesAction[], activityLogs: Pick<ActivityElement, "Children">[]): KubernetesStepWithStatus[] {
    const stepsWithStatus = useMemo(() => kubernetesSteps.map((step) => {
        const activity = getStepActivity(step.stepName, activityLogs) ?? { Name: step.stepName, Started: "", Ended: "", Status: ActivityStatus.Pending };
        return {
            ...step,
            status: activity.Status,
        };
    }), [kubernetesSteps, activityLogs]);
    //The activityLogs changes object each time the task page refreshes, but we transform this into an array of simpler objects
    //useMemo only does object comparisons, so even if the array contents are the same, the object ref is different, causing the tree to recalculate (and force a rerender)
    //we don't want to recalculate the tree each time, so do a deep comparison memo so if the array of objects are all the same, then don't change
    const superMemodStepsWithStatus = useDeepCompareMemo(stepsWithStatus);
    //i like this name, so will keep these two lines separated :joy:
    return superMemodStepsWithStatus;
}
